var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBuilding(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.383)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    transform: "translate(5 5.617)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    transform: "translate(5 9.617)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    transform: "translate(9 5.617)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    transform: "translate(9 9.617)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    transform: "translate(5 13.617)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    transform: "translate(9 13.617)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.915,10.106a1.351,1.351,0,0,0-1.351-1.351H15.511v-5.4A1.351,1.351,0,0,0,14.16,2H3.351A1.351,1.351,0,0,0,2,3.351V20.915H20.915ZM3.351,3.351H14.16V19.564H3.351Zm12.16,16.213V10.106h4.053v9.458Z",
    transform: "translate(-0.649 -0.649)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.67c7e18cedf390f4d21aa26beed40751.svg";
export { ForwardRef as ReactComponent };